import { Component, Input } from '@angular/core';
import { CustomerType } from '../../../models';
import { ColorUtils } from '../../../utils';

@Component({
  selector: 'lib-customer-type-badge',
  templateUrl: './customer-type-badge.component.html',
  styleUrl: './customer-type-badge.component.scss',
})
export class CustomerTypeBadgeComponent {
  private _customerType: CustomerType;
  @Input() set customerType(value: CustomerType) {
    this._customerType = value;
    this.backgroundColor = ColorUtils.getCustomerColorToDisplay(value?.name);
    this.textColor = ColorUtils.getCustomerAvatarTextColorToDisplay(
      value?.name
    );
  }
  get customerType(): CustomerType {
    return this._customerType;
  }

  public backgroundColor: string;
  public textColor: string;
}
